import { WarpCore, TokenAmount } from "@hyperlane-xyz/sdk";

import { useQuery } from "@tanstack/react-query";
import {
  getTokenByIndex,
  useWarpCore,
} from "modules/bridge/hyperlane/features/tokens/hooks";

import { logger } from "modules/bridge/hyperlane/utils/logger";
import { Address } from "viem";
import { useAccount } from "wagmi";

const FEE_QUOTE_REFRESH_INTERVAL = 15_000; // 10s

interface Params {
  destination: string;
  tokenIndex: number;
}
export function useFeeQuotes(
  { destination, tokenIndex }: Params,
  enabled: boolean
) {
  const { address } = useAccount();
  const warpCore = useWarpCore();
  const { isLoading, isError, data } = useQuery({
    queryKey: ["useFeeQuotes", destination, tokenIndex, address],
    queryFn: () => fetchFeeQuotes(warpCore, destination, tokenIndex, address),
    enabled,
    refetchInterval: FEE_QUOTE_REFRESH_INTERVAL,
  });

  return { isLoading, isError, fees: data };
}
async function fetchFeeQuotes(
  warpCore: WarpCore,
  destination?: ChainName,
  tokenIndex?: number,
  sender?: Address
): Promise<TokenAmount | null> {
  const originToken = getTokenByIndex(warpCore, tokenIndex);
  if (!destination || !sender || !originToken) return null;
  logger.debug("Fetching fee quotes");
  return warpCore.getInterchainTransferFee({
    originToken,
    destination,
  });
}
